import { Suspense } from 'react'
import { DocumentReviewLayout } from '~/widgets/document-review-layout'
import { Classification } from './classification/classification'
import { LoadingSkeleton } from './classification/loading-skeleton'

export function DocumentClassificationPage() {
  return (
    <DocumentReviewLayout
      step="Classification"
      loader={<LoadingSkeleton />}
    >
      <Suspense fallback={<LoadingSkeleton />}>
        <Classification />
      </Suspense>
    </DocumentReviewLayout>
  )
}
